import React from 'react';
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableContainer,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getNexusTokens } from '../../theme/tokens';

/**
 * Thin table wrapper: consistent container, loading, and empty states (Phase 7.2).
 * Pass TableHead / TableBody as children.
 */
export default function DataTable({
  children,
  loading = false,
  empty = false,
  emptyMessage = 'No data to display',
  stickyHeader = false,
  component = Paper,
  minHeight = 200,
  sx,
  tableSx,
}) {
  const theme = useTheme();
  const tokens = getNexusTokens(theme);

  return (
    <TableContainer
      component={component}
      sx={{
        background: tokens.colors.gradient.surface,
        border: `1px solid ${tokens.colors.border.default}`,
        borderRadius: `${tokens.radius.lg}px`,
        overflowX: 'auto',
        // Allow row content (e.g. GroupShareStatus Collapse) to expand.
        // overflowY:hidden clipped expandable per-group share lists in Posts.
        overflowY: 'auto',
        maxWidth: '100%',
        ...sx,
      }}
    >
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight,
            gap: 2,
            py: 4,
          }}
        >
          <CircularProgress size={32} />
          <Typography variant="body2" sx={{ color: tokens.colors.text.secondary }}>
            Loading…
          </Typography>
        </Box>
      ) : empty ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight,
            py: 4,
            px: 3,
          }}
        >
          <Typography variant="body2" sx={{ color: tokens.colors.text.secondary }}>
            {emptyMessage}
          </Typography>
        </Box>
      ) : (
        <Table stickyHeader={stickyHeader} sx={tableSx}>
          {children}
        </Table>
      )}
    </TableContainer>
  );
}
